import { render, staticRenderFns } from "./addImg.vue?vue&type=template&id=678e1aaa&scoped=true&"
import script from "./addImg.vue?vue&type=script&lang=js&"
export * from "./addImg.vue?vue&type=script&lang=js&"
import style0 from "./addImg.vue?vue&type=style&index=0&id=678e1aaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678e1aaa",
  null
  
)

export default component.exports